import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable, TaxProductCodeFilterSpec, WrapperPageableResponse } from './service-common';

export interface TaxProductCodeDTO {
  id: number;
  taxCode: string;
  taxDescription: string;
  effectiveDate?: string;
  expiryDate?: string;
  state?: 'ACTIVE' | 'INACTIVE';
}

export type WrapperPageableResponseTaxProductCodeDTO = WrapperPageableResponse<TaxProductCodeDTO>;

@Injectable({
  providedIn: 'root'
})
export class TaxProductCodeService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  searchTaxProductCodes(
    spec: TaxProductCodeFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseTaxProductCodeDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseTaxProductCodeDTO>(
      `${this.apiUrl}/tax-product-codes`,
      { params }
    );
  }

  listTaxProductCodes(
    spec: TaxProductCodeFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseTaxProductCodeDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseTaxProductCodeDTO>(`${this.apiUrl}/tax-product-codes/list`,{ params });
  }
}
